export const faqs = [
  {
    question: '蝌蚪吃瓜的时间线是怎么梳理出来的？',
    answer:
      '编辑会先把公开信息按时间先后排好，标出「起点、发酵、回应、结局」四个阶段，再逐一核对每条信息出现的时间与出处。只有能被至少两个来源互相印证的内容，才会进入正式时间线；存在争议的说法会单独标注为「待确认」，不与已确认信息混在一起。',
  },
  {
    question: '为什么同一件事会有多个版本的说法？',
    answer:
      '娱乐事件的当事人、团队、平台和观众往往处在不同位置，各自掌握的片段并不相同。我们不会挑一个版本当成唯一真相，而是把不同说法按时间并列展示，注明各自出现的时间点，让读者自己看清分歧究竟发生在哪一步。',
  },
  {
    question: '时间线会不会随时变化？',
    answer:
      '会。事件仍在发展时，时间线会持续追加新节点，并在文首显示「最后更新」时间；已经发生的节点原则上不改写，若确有信息更正，会在节点旁保留修订说明。这样你隔几天回来，依然能一眼看出哪里是新进展。',
  },
  {
    question: '前因后果深度拆解包含哪些内容？',
    answer:
      '每篇拆解分为三块：前因说明事情发生的背景与导火索，经过按时间顺序列出关键节点与各方回应，当后果则总结事件当下造成的实际影响。三块内容互相独立又彼此衔接，方便你只看关心的那一段。',
  },
  {
    question: '可以投稿或者指出时间线里的错误吗？',
    answer:
      '可以。通过「联系我们」页面提交线索或更正即可，建议附上信息出现的时间与来源链接。编辑会先核对，再决定是补充新节点还是修订已有节点，并在页面上标注更新记录。',
  },
  {
    question: '站内的内容和品牌是什么关系？',
    answer:
      '蝌蚪吃瓜是独立的内容整理站点，站内案例为编辑整理的娱乐话题复盘，人物与作品名称均使用站内叙事代号，不代表任何真实主体的立场，也与所涉品牌和平台没有从属关系。',
  },
];